/*jslint white: true, browser: true, devel: true, nomen: true, sloppy: true, indent: 4, maxerr: 50,	 plusplus: true, vars: false */
/*jshint -W030, -W041, -W098 */

CanvasRenderingContext2D.prototype.fillRoundRect = function (x, y, w, h, r) {
    if (w < 2 * r) r = w / 2;
    if (h < 2 * r) r = h / 2;
    this.beginPath();
    this.moveTo(x+r, y);
    this.arcTo(x+w, y,   x+w, y+h, r);
    this.arcTo(x+w, y+h, x,   y+h, r);
    this.arcTo(x,   y+h, x,   y,   r);
    this.arcTo(x,   y,   x+w, y,   r);
    this.closePath();
    this.fill();
};

function SliderView() {
    "use strict";

    var self = this,
        drawDOM;

    self.viewConfig = {
        background: "white",
        labels: ["Narrow", "Normal", "Wide"],
        shortLabels: [],
        leftValue: 50,
        rightValue: 50,
        leftIntervalLabel: "Left",
        rightIntervalLabel:  "Right",
        allCaps: true,
        textCentered: false,

        textFont: "14pt UCSLato",
        textFontLR: "14px UCSLato",
        textLRBold: false,
        sliderTextColor: "#5E6B76",
        footTextColor: "#1D70B7",
        sliderBackgroundColor: "#E7E7E7",
        sliderOuterBarsColor: "#5E6B76",
        sliderInnerBarsColor: "#AAAAAA",
        sliderTriangleColor: "#1D70B7",
        sliderHeight: 45,
        sliderBorderRadius: 0,
        sliderSideMargin: 15,
        sliderSidePadding: 10,
        sliderOuterBarsWidth: 6,
        sliderInnerBarsWidth: 3,
        sliderInnerBarsFractionHeight: 3,
        footTextMargin: 15,
        triangleWidth: 20,
        triangleHeight: 25,
        sliderOuterBarsVisible: true
    };

    function drawTriangle(ctx, x, y, top, config) {
        ctx.beginPath();
        ctx.moveTo(x - config.triangleWidth / 2, y);
        ctx.lineTo(x + config.triangleWidth / 2, y);
        if(top)
            ctx.lineTo(x, y + config.triangleHeight);
        else
            ctx.lineTo(x, y - config.triangleHeight);
        ctx.lineTo(x - config.triangleWidth / 2, y);
        ctx.fill();
    }

    this.draw = function (resized) {
        var canvasHeight0,
            canvasWidth0,
            ctx, elem,
            config = self.viewConfig,
            ratio = 1;

        resized = resized || !drawDOM.canvasHeight;

        if (resized) {
            resizeCanvas(ratio);
            if (!drawDOM.canvasHeight) return;
        }

        elem = drawDOM.myCanvas;
        if (!elem || !elem.getContext) {
            return;
        }
        ctx = elem.getContext('2d');
        if (!ctx) {
            return;
        }

        var dPR = window.devicePixelRatio || 1,
            bSR = ctx.webkitBackingStorePixelRatio ||
                ctx.mozBackingStorePixelRatio ||
                ctx.msBackingStorePixelRatio ||
                ctx.oBackingStorePixelRatio ||
                ctx.backingStorePixelRatio || 1;
        ratio = dPR / bSR >= 1 ? dPR / bSR : 1;
        resizeCanvas(ratio);

        /* --------------------------------------------------------- */
        canvasWidth0 = ctx.canvas.width;
        canvasHeight0 = ctx.canvas.height;
        ctx.clearRect(0, 0, canvasWidth0, canvasHeight0);
        ctx.fillStyle = config.background;
        ctx.fillRect(0, 0, canvasWidth0, canvasHeight0);

        ctx.save();
        var radius,
            DPIValues = config.scaledValues,
            sliderWidth = canvasWidth0 - 2*DPIValues.sliderSideMargin;

        // draw slider background and bars
        ctx.fillStyle = config.sliderBackgroundColor;

        ctx.fillRoundRect(config.sliderSideMargin, canvasHeight0/2-DPIValues.sliderHeight/2, sliderWidth, DPIValues.sliderHeight, DPIValues.sliderBorderRadius);

        radius = Math.floor(DPIValues.sliderInnerBarsWidth/2);
        ctx.fillStyle = config.sliderInnerBarsColor;
        ctx.fillRoundRect(DPIValues.sliderSideMargin + sliderWidth/3-radius, canvasHeight0/2-DPIValues.sliderHeight/(self.viewConfig.sliderInnerBarsFractionHeight*2)-DPIValues.sliderInnerBarsWidth/2, DPIValues.sliderInnerBarsWidth, DPIValues.sliderHeight/(self.viewConfig.sliderInnerBarsFractionHeight)+DPIValues.sliderInnerBarsWidth, radius);
        ctx.fillRoundRect(DPIValues.sliderSideMargin + sliderWidth/1.5-radius, canvasHeight0/2-DPIValues.sliderHeight/(self.viewConfig.sliderInnerBarsFractionHeight*2)-DPIValues.sliderInnerBarsWidth/2, DPIValues.sliderInnerBarsWidth, DPIValues.sliderHeight/(self.viewConfig.sliderInnerBarsFractionHeight)+DPIValues.sliderInnerBarsWidth, radius);

        if(config.sliderOuterBarsVisible) {
            radius = Math.floor(DPIValues.sliderOuterBarsWidth/2);
            ctx.fillStyle = config.sliderOuterBarsColor;
            ctx.fillRoundRect(DPIValues.sliderSideMargin-radius, canvasHeight0/2-DPIValues.sliderHeight/2-DPIValues.sliderOuterBarsWidth/2, DPIValues.sliderOuterBarsWidth, DPIValues.sliderHeight+DPIValues.sliderOuterBarsWidth, radius);
            ctx.fillRoundRect(canvasWidth0 - DPIValues.sliderSideMargin-radius, canvasHeight0/2-DPIValues.sliderHeight/2-DPIValues.sliderOuterBarsWidth/2, DPIValues.sliderOuterBarsWidth, DPIValues.sliderHeight+DPIValues.sliderOuterBarsWidth, radius);
        }


        // update text to fit in space available
        ctx.font = DPIValues.textFont;
        config.shortLabels.length = 0;
        for (var idx in config.labels) {
            if(config.allCaps) {
                config.labels[idx] = config.labels[idx].toUpperCase();
            }
            if( ctx.measureText(config.labels[idx]).width > sliderWidth/3 - 2*DPIValues.sliderSidePadding) {
                for (var i = config.labels[idx].length; i > 1; i--) {
                    config.shortLabels[idx] = config.labels[idx].substring(0, i-1);
                    if(i > 2) config.shortLabels[idx] += ".";
                    if(ctx.measureText(config.shortLabels[idx]).width < sliderWidth/3 - 2*DPIValues.sliderSidePadding) break;
                }
            } else {
                config.shortLabels[idx] = config.labels[idx];
            }
        }
        // draw text
        ctx.fillStyle = config.sliderTextColor;
        ctx.textBaseline = 'middle';
        if(self.viewConfig.textCentered) {
            ctx.textAlign = 'center';
            ctx.fillText(config.shortLabels[0], canvasWidth0 / 6 * 1, canvasHeight0 / 2);
            ctx.fillText(config.shortLabels[1], canvasWidth0 / 2, canvasHeight0 / 2);
            ctx.fillText(config.shortLabels[2], canvasWidth0 / 6 * 5, canvasHeight0 / 2);
            ctx.textAlign= 'left';
        } else {
            ctx.fillText(config.shortLabels[0], DPIValues.sliderSideMargin + DPIValues.sliderSidePadding, canvasHeight0 / 2);
            ctx.fillText(config.shortLabels[1], canvasWidth0 / 2 - ctx.measureText(config.shortLabels[1]).width / 2, canvasHeight0 / 2);
            ctx.fillText(config.shortLabels[2], canvasWidth0 - DPIValues.sliderSideMargin - DPIValues.sliderSidePadding - ctx.measureText(config.shortLabels[2]).width, canvasHeight0 / 2);
        }
        // draw foot text and indicator
        ctx.fillStyle = config.sliderTriangleColor;
        if(config.leftValue) drawTriangle(ctx, DPIValues.sliderSideMargin + sliderWidth/100*config.leftValue, canvasHeight0/2-DPIValues.sliderHeight/2-DPIValues.footTextMargin/2, true, DPIValues);
        if(config.rightValue) drawTriangle(ctx, DPIValues.sliderSideMargin + sliderWidth/100*config.rightValue, canvasHeight0/2+DPIValues.sliderHeight/2+DPIValues.footTextMargin/2, false, DPIValues);

        ctx.fillStyle = config.footTextColor;
        if(config.allCaps) {
            config.leftIntervalLabel = config.leftIntervalLabel.toUpperCase();
            config.rightIntervalLabel = config.rightIntervalLabel.toUpperCase();
        }
        ctx.font = (self.viewConfig.textLRBold ? "Bold " : "") + DPIValues.textFontLR;
        ctx.textBaseline = 'alphabetic';
        ctx.fillText(config.leftIntervalLabel, DPIValues.sliderSideMargin + sliderWidth/100*config.leftValue - ctx.measureText(config.leftIntervalLabel).width/2, canvasHeight0/2-DPIValues.sliderHeight/2-DPIValues.footTextMargin);
        ctx.textBaseline = 'hanging';
        ctx.fillText(config.rightIntervalLabel, DPIValues.sliderSideMargin + sliderWidth/100*config.rightValue - ctx.measureText(config.rightIntervalLabel).width/2, canvasHeight0/2+DPIValues.sliderHeight/2+DPIValues.footTextMargin-1);
        ctx.font = DPIValues.textFont;

        ctx.restore();
        return;

    };

    function resizeCanvas(ratio) {
        var wrapper = drawDOM.canvasWrapper;
        /*drawDOM.myCanvas.style.width = wrapper.clientWidth;
        drawDOM.myCanvas.style.height = wrapper.clientHeight;*/
        drawDOM.myCanvas.width = wrapper.clientWidth * ratio;
        drawDOM.canvasHeight = drawDOM.myCanvas.height = wrapper.clientHeight * ratio;
        var fontParts = self.viewConfig.textFont.split(" ");
        var fontSize = fontParts[0], fontFamily = fontParts[1];
        try {
            fontSize = parseInt(fontSize) * ratio + "px";
        } catch (err) {
            console.log("Error: " + err);
        }
        fontParts = self.viewConfig.textFontLR.split(" ");
        var fontLRSize = fontParts[0], fontLRFamily = fontParts[1];
        try {
            fontLRSize = parseInt(fontLRSize) * ratio + "px";
        } catch (err) {
            console.log("Error: " + err);
        }

        self.viewConfig.scaledValues = {
            textFont: fontSize + " " + fontFamily,
            textFontLR: fontLRSize + " " + fontLRFamily,
            sliderHeight: self.viewConfig.sliderHeight*ratio,
            sliderBorderRadius: self.viewConfig.sliderBorderRadius*ratio,
            sliderSideMargin: self.viewConfig.sliderSideMargin*ratio,
            sliderSidePadding: self.viewConfig.sliderSidePadding*ratio,
            sliderOuterBarsWidth: self.viewConfig.sliderOuterBarsWidth*ratio,
            sliderInnerBarsWidth: self.viewConfig.sliderInnerBarsWidth*ratio,
            sliderInnerBarsFractionHeight: self.viewConfig.sliderInnerBarsFractionHeight*ratio,
            footTextMargin: self.viewConfig.footTextMargin*ratio,
            triangleWidth: self.viewConfig.triangleWidth*ratio,
            triangleHeight: self.viewConfig.triangleHeight*ratio
        };
    }

    this.setResized = function () {
        drawDOM.canvasHeight = 0;
    };

    /**
     * Initialize
     * @param {Element} canvas        [[Description]]
     * @param {Element} canvasWrapper [[Description]]
     * @param {Object} config          [[Description]]
     */
    this.init = function (canvas, canvasWrapper, config) {
        for(var param in config) {
            if(param === 'sliderInnerBarsFractionHeight' && (isNaN(config[param]) || config[param] < 0.9)) continue; //prevent non-numeric or too small value.
            self.viewConfig[param] = config[param];
        }

        try {
            drawDOM = {
                myCanvas: canvas,
                canvasWrapper: canvasWrapper,
                canvasHeight: 0
            };

            // utl.apply(config.viewConfig, self.viewConfig, true);
            // self.viewConfig = config.viewConfig;

        } catch (e) {
            console.log("Error " + e);
        }
    };

    this.clearData = function () {
        self.leftFoot = {
            contour: {
                data: []
            }
        };
        self.rightFoot = {
            contour: {
                data: []
            }
        };
    };

    this.clear = function (resize) {

        try {
            self.clearData();

            //self.draw(resize);
            var elem, ctx;
            elem = drawDOM.myCanvas;
            if (elem && elem.getContext) {
                ctx = elem.getContext('2d');
                if (ctx) {
                    if (resize)
                        resizeCanvas();
                    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                }
            }

        } catch (err) {
            console.log("clear error" + err.stack);
        }
    };

    this.dispose = function () {
        drawDOM = null;
    };

    //init
    this.clearData();
}
